<script>
  import popper from '@/packages/tooltip/mixins/popper'
  import Vue from 'vue'

  const PLACEMENT = [
    'auto',
    'auto-start',
    'auto-end',
    'top',
    'top-start',
    'top-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'right',
    'right-start',
    'right-end',
    'left',
    'left-start',
    'left-end'
  ]

  const TRIGGER = ['focus', 'none']

  const showEvents = ['mouseenter', 'focus']
  const hideEvents = ['mouseleave', 'blur']

  export default {
    name: 'FddTooltip',
    mixins: [popper],
    props: {
      content: {
        type: String,
        default: ''
      },
      delay: {
        type: Number,
        default: 200
      },
      appendToBody: {
        type: Boolean,
        default: true
      },
      maxWidth: {
        type: [Number, String],
        default: 600
      },
      strategy: {
        type: String,
        default: 'fixed'
      },
      placement: {
        type: String,
        default: 'top',
        validator(value) {
          return ~PLACEMENT.indexOf(value)
        }
      },
      trigger: {
        type: String,
        default: 'focus',
        validator(value) {
          return ~TRIGGER.indexOf(value)
        }
      },
      light: Boolean
    },
    beforeCreate() {
      const Template = Vue.extend({
        data() {
          return { node: '' }
        },
        render(h) {
          return this.node
        }
      })
      this.popperVM = new Template().$mount()
    },
    mounted() {
      this.referenceElm = this.$el
      if (this.trigger !== 'none') {
        showEvents.forEach(event => this.$el.addEventListener(event, this.handleMouseEnter, false))
        hideEvents.forEach(event => this.$el.addEventListener(event, this.handleMouseLeave, false))
      } else {
        this.handleMouseEnter()
      }
    },
    beforeDestroy() {
      this.popperVM && this.popperVM.$destroy()
    },
    destroyed() {
      if (this.$el.nodeType === 1 && this.trigger !== 'none') {
        showEvents.forEach(event => this.$el.removeEventListener(event, this.show, false))
        hideEvents.forEach(event => this.$el.removeEventListener(event, this.handleMouseLeave, false))
      }
    },
    methods: {
      handleMouseEnter() {
        if (this.timeout) clearTimeout(this.timeout)
        this.clearCloseTimeout()
        this.timeout = setTimeout(() => {
          this.visible = true
        }, this.delay)
      },
      handleMouseLeave() {
        this.clearCloseTimeout()
        this.timeoutClose = setTimeout(() => {
          this.visible = false
        }, this.delay)
      },
      getFirstElement() {
        const slots = this.$slots.default
        if (!Array.isArray(slots)) return null
        let element = null
        for (let index = 0; index < slots.length; index++) {
          if (slots[index] && slots[index].tag) {
            element = slots[index]
          }
        }
        return element
      },
      clearCloseTimeout() {
        if (this.timeoutClose) clearTimeout(this.timeoutClose)
      }
    },
    render(h) {
      if (this.popperVM) {
        this.popperVM.node = (
          <transition name="fade" onAfterLeave={this.destroyPopper}>
            <div
              v-show={this.showPopper}
              onMouseleave={() => {
                this.trigger !== 'none' && this.handleMouseLeave()
              }}
              onMouseenter={() => {
                this.trigger !== 'none' && this.clearCloseTimeout()
              }}
              ref="popper"
              class={['tooltip-popper', { 'is-light': this.light }]}
            >
              <div class="tooltip-text" style={{ 'max-width': this.maxWidth + 'px' }}>
                {this.$slots.content || (this.$scopedSlots.content && this.$scopedSlots.content()) || this.content}
              </div>
              <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
          </transition>
        )
      }

      const firstElement = this.getFirstElement()
      if (!firstElement) return null

      return firstElement
    }
  }
</script>
<style scoped lang="less">
  @import 'tooltip';
</style>
